<template>
  <div class="unauthorized-container">
    <h1>403 - 未授权访问</h1>
    <p>抱歉，您没有权限访问此页面</p>
    <div class="btn-group">
      <el-button @click="goBack">返回上一页</el-button>
      <el-button type="primary" @click="logout">退出登录</el-button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/store/modules/auth';

const router = useRouter();
const authStore = useAuthStore();

const goBack = () => {
  router.go(-1);
};

const logout = () => {
  authStore.logout();
  router.push('/login');
};
</script>

<style scoped>
.unauthorized-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
}

h1 {
  font-size: 48px;
  margin-bottom: 20px;
  color: #f56c6c;
}

p {
  font-size: 18px;
  margin-bottom: 30px;
  color: #606266;
}

.btn-group {
  display: flex;
  gap: 10px;
}
</style>